import GridKeikka_NewKeikka_NewKeikkaButton from "../components/GridKeikka_NewKeikka_NewKeikkaButton";
import PropTypes from "prop-types";
import { useContext, useState } from "react";
import { GridKeikka_NewKeikkaContext } from "src/context/GridKeikka_NewKeikkaContext";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import AsiakasSelectorAutocompleteModal from "src/components/asiakas/list/AsiakasSelectorAutocompleteModal";
import GridKeikka_NewKeikkaLayout_Accordion from "./GridKeikka_NewKeikkaLayout_Accordion";
import GridKeikkaEditor_SourceAsiakasSettingsModal from "../../GridKeikkaEditor/GridKeikkaEditor_SourceAsiakasSettingsModal/GridKeikkaEditor_SourceAsiakasSettingsModal";
import { stat_addRowToStat2 } from "src/data/stat/statFunctions";
import { getMonth, getYear } from "date-fns";
import { useUserData } from "src/context/userContext";
import { GridContext } from "src/context/GridContext/GridContext";
import { asiakas_cacheName, cache_clear } from "src/components/js/CacheFunctions";

export default function GridKeikka_NewKeikkaLayout({ onSelect }) {
  const { gridKeikkaEditorIsOpen } = useContext(GridContext) || {};
  const { isLoaded, isError, reload } = useContext(GridKeikka_NewKeikkaContext);
  const { userAsiakas, token } = useUserData();
  const [addNewAsiakas_isOpen, addNewAsiakas_setIsOpen] = useState(false);
  const [source, setSource] = useState(null); // source, betoni, pumppu
  const [isEditSourceAsiakasOpen, setIsEditSourceAsiakasOpen] = useState(false);

  if (isError || !isLoaded)
    return (
      <div className="center" style={{ paddingBottom: 30 }}>
        {isError ? <>Error...</> : <ProgressBar show height={2} />}
      </div>
    );

  const handleAddNewAsiakasClicked = (source) => {
    addNewAsiakas_setIsOpen(true);
    cache_clear(asiakas_cacheName);
    setSource(source);
  };
  const handleAddNewAsiakasSelected = async (asiakas) => {
    let pumppuAsiakasId = source === "pumppu" ? asiakas.asiakasId : 0;
    let betoniAsiakasId = source === "betoni" ? asiakas.asiakasId : 0;
    let sourceAsiakasId = source === "source" ? asiakas.asiakasId : userAsiakas.asiakasId;

    await stat_addRowToStat2(
      getYear(new Date()),
      getMonth(new Date()) + 1,
      userAsiakas.asiakasId,
      sourceAsiakasId,
      pumppuAsiakasId,
      betoniAsiakasId,
      token
    );
    await reload();
    addNewAsiakas_setIsOpen(false);
  };

  const label = (source) => {
    switch (source) {
      case "source":
        return "Valitse tilauksen vastaanottanut asiakas";
      case "betoni":
        return "Valitse tilaukselle betonivalmistaja";
      case "pumppu":
        return "Valitse tilaukselle pumpputoimittaja";
      default:
        return "Asiakas";
    }
  };
  const helpId = (source) => {
    switch (source) {
      case "source":
        return "grid_keikka_source_asiakas";
      case "betoni":
        return "grid_keikka_source_betoni";
      case "pumppu":
        return "grid_keikka_source_pumppu";
      default:
        return null;
    }
  };

  const handleSourceAsiakasSelectorClick = () => {
    setIsEditSourceAsiakasOpen(true);
  };

  return (
    <>
      <AsiakasSelectorAutocompleteModal
        isOpen={addNewAsiakas_isOpen}
        setIsOpen={addNewAsiakas_setIsOpen}
        onSelect={handleAddNewAsiakasSelected}
        source={source}
        title="Asiakas"
        label={label(source)}
        helpId={helpId(source)}
      />
      <GridKeikkaEditor_SourceAsiakasSettingsModal
        isOpen={isEditSourceAsiakasOpen}
        onClose={() => setIsEditSourceAsiakasOpen(false)}
      />
      <div className="newKeikka_mainDiv">
        <GridKeikka_NewKeikka_NewKeikkaButton onSelect={onSelect} />
        {!gridKeikkaEditorIsOpen && (
          <GridKeikka_NewKeikkaLayout_Accordion
            onAddNewAsiakasClicked={handleAddNewAsiakasClicked}
            onEditSourceClick={handleSourceAsiakasSelectorClick}
          />
        )}
      </div>
    </>
  );
}

GridKeikka_NewKeikkaLayout.propTypes = {
  onSelect: PropTypes.func,
};
